import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProfileImageEntry {
  affAbo: string;
  profileImage: string;
}

interface ProfileImagesState {
  images: Record<string, string>; // affAbo -> base64 string
  fetched: string[]; // affAbos that have been fetched (even if no image returned)
  failed: string[]; // affAbos that failed to fetch
}

const initialState: ProfileImagesState = {
  images: {},
  fetched: [],
  failed: [],
};

const profileImagesSlice = createSlice({
  name: "profileImages",
  initialState,
  reducers: {
    addProfileImages: (
      state,
      action: PayloadAction<{
        affAbos: string[];
        images: ProfileImageEntry[];
      }>,
    ) => {
      const { affAbos, images } = action.payload;
      state.fetched.push(...affAbos);
      for (const entry of images) {
        if (entry.profileImage) {
          state.images[entry.affAbo] = entry.profileImage;
        }
      }
    },
    markProfileImagesFailed: (
      state,
      action: PayloadAction<{
        affAbos: string[];
      }>,
    ) => {
      state.failed.push(...action.payload.affAbos);
    },
  },
});

export const { addProfileImages, markProfileImagesFailed } = profileImagesSlice.actions;
export default profileImagesSlice.reducer;
